import styled from 'styled-components';

export default styled.div`
  background-color: ${`${window?.settings?.secondary_color ?? '#04333b'}99`};
  backdrop-filter: blur(6px);
  z-index: 10;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;
